import { createGlobalStyle } from 'styled-components';
import {basicColor} from './template';
import BS from '../assets/fonts/bs-bold.woff2'

let fontBs = '';
// на сайте шрифт уже подключен поэтому только для dev
//url("/local/templates/main/fonts/bs-bold.woff2")

if(import.meta.env.DEV){
    fontBs =  `
        @font-face {
          font-family: 'BS';
          src: url(${BS}) format('woff2');
          font-weight: bold; // был ранее 600
          font-style: normal;
          font-display: swap;
        }
    `;
}

export default createGlobalStyle`
    :root {
      font-synthesis: none;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-text-size-adjust: 100%;
    }

    ${fontBs}

    *,
    *::before,
    *::after {
      -webkit-box-sizing: border-box;
          box-sizing: border-box;
    }
    
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        vertical-align: baseline;
    }

    html {
        font-size: 8px; /* for using REM units */
        cursor: default;
        -moz-tab-size: 4;
        -o-tab-size: 4;
        tab-size: 4;
        -webkit-tap-highlight-color: transparent; /* Remove the grey highlight on links in iOS. */
        -ms-text-size-adjust: 100%; /* Prevent adjustments of font size after orientation changes in */
        -webkit-text-size-adjust: 100%; 
        word-break: break-word; 
    }

    body {
        font-family: 'Roboto', sans-serif;
        font-size: 2rem;
        font-weight: 400;
        line-height: 1.5;
        background: ${props => props.theme.color.Background};
        color: ${props => props.theme.color.Text};
        min-height: 100vh;
        scroll-behavior: smooth;
        text-rendering: optimizeSpeed;
    }

    textarea {
        overflow: auto;
        resize: vertical;
    }

    hr {
        height: 0; /* Add the correct sizing in Firefox */
        overflow: visible; /* Show the overflow in Edge 18- and IE */ 
    }

    main {
      display: block; /* Add the correct display in IE. */
    }

    ul[class], nav ul,
    ol[class], nav ol {
      list-style: none;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }

    [type="checkbox"],
    [type="radio"] {
      padding: 0;
    }

    [type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
    }

    pre {
        font-family: monospace, monospace;
        font-size: 1em;
        overflow: initial;
    }

    a {
      text-decoration: none;
      background-color: transparent;
      color: ${props => props.theme.color.Text};
    }

    iframe {
      border-style: none; 
    }

    img {
      max-width: 100%;
      display: block;
      border-style: none;
    }

    svg:not(:root) {
      overflow: hidden; /* Hide the overflow in IE. */
    }

    table {
      border-collapse: collapse; 
    }

    /* Natural flow and rhythm in articles by default */
    //article > * + * {
    //  margin-top: 1em;
    //}

    input,
    button,
    textarea,
    select {
      font: inherit;
      border: none;
      outline: none;
    }

    form, input, select, textarea {
      width: 100%;
    }

    input[type=submit],
    input[type=reset],
    input[type=button],
    button
     {
        padding: 0;
        border: none;
        overflow: visible;
        text-transform: none;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        transition: 220ms all ease-in-out;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background: none;
    }

    input[type=submit]::-moz-focus-inner,
    input[type=reset]::-moz-focus-inner,
    input[type=button]::-moz-focus-inner,
    button::-moz-focus-inner {
      padding: 0; 
    }

    input[type=submit]:focus,
    input[type=reset]:focus,
    input[type=button]:focus,
    button:focus,
    input:focus {
      outline: 0;
    }

    input[type=submit]:disabled,
    input[type=reset]:disabled,
    input[type=button]:disabled,
    button:disabled {
      cursor: not-allowed;
    }

    input[type="number"] {
  -webkit-appearance: textfield;
     -moz-appearance: textfield;
          appearance: textfield;
    }
    //input[type=number]::-webkit-inner-spin-button, 
    //input[type=number]::-webkit-outer-spin-button { 
    //  -webkit-appearance: none;
    //}

    button,
    [type="button"],
    [type="reset"],
    [type="submit"] {
      -webkit-appearance: button; 
    }

    ::-moz-focus-inner {
        border-style: none;
        padding: 0; 
    }

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: ${({ theme }) => theme.color.MidtoneItem};
      opacity: 1; 
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: ${({ theme }) => theme.color.MidtoneItem};
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
      color: ${({ theme }) => theme.color.MidtoneItem};
    }

    .rec.rec-dot, 
	    .rec.rec-dot.rec-dot_active {
			box-shadow: none;
			border: none;
	    }

	    .rec.rec-dot {
	    	background: ${basicColor.white};
	    	width: 1rem;
	    	height: 1rem;
	    	margin: 0.5rem;
	    }

	    .rec.rec-dot.rec-dot_active {
	    	background: ${basicColor.accent};
	    	width: 3rem;
	    	border-radius: 1rem;
	    }


    @media screen and (-ms-high-contrast: active) {
        border: 2px solid currentcolor;
      }

    /* Remove all animations and transitions for people that prefer not to see them */
    @media (prefers-reduced-motion: reduce) {
      * {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
      }
    }

    /* Устанавливаем ширину вертикального скролла */
    ::-webkit-scrollbar {
        width: 6px;
    }

    /* Устанавливаем высоту горизонтального скролла */
    ::-webkit-scrollbar:horizontal {
        height: 0.5rem;
    }

    /* Трек (фон скролла) */
    ::-webkit-scrollbar-track {
        background: transparent !important;
        border-radius: 10px;
        box-shadow: none; /* Убираем тени */
    }

    /* Ползунок (рукоятка скролла) */
    ::-webkit-scrollbar-thumb {
        background: ${basicColor.darkGray};
        border-radius: 10px;
    }

    /* Ползунок при наведении */
    ::-webkit-scrollbar-thumb:hover {
        background: ${basicColor.accent}; 
    }


    div.rec-slider-container {
      margin: 0;
    }

    .lazy-image-container {
        margin: 0 auto;
        max-width: 100%;
    }
    
    .table-wrapper {
        width: 100%;
        overflow-x: auto; 
        -webkit-overflow-scrolling: touch;
    }


    
`;


